(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-scroller"] && !Shopify.designMode) return;
  try {
    (function () {
        function initScroller(wrap) {
            var track = wrap.querySelector('.collection-scroller__track');
            if (!track || wrap.dataset.csReady) return;
            wrap.dataset.csReady = '1';
            var prev = wrap.querySelector('.cs-nav--prev');
            var next = wrap.querySelector('.cs-nav--next');

            function update() {
                var maxScroll = track.scrollWidth - track.clientWidth;
                var overflows = maxScroll > 4;
                wrap.classList.toggle('cs-has-overflow', overflows);
                if (prev) prev.disabled = track.scrollLeft <= 2;
                if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
            }
            function step(dir) {
                track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
            }
            if (prev) prev.addEventListener('click', function () { step(-1); });
            if (next) next.addEventListener('click', function () { step(1); });
            track.addEventListener('scroll', update, { passive: true });
            window.addEventListener('resize', update);
            update();
        }
        function initAll() {
            document.querySelectorAll('.collection-scroller__wrap').forEach(initScroller);
        }
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initAll);
        } else {
            initAll();
        }
    })();
  } catch(e) { console.error(e); }
})();

})();
